import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

import ContactDetails from 'vcomponents/common/object/ContactDetails.vue';
import { OBJECT_BLOCK_VARIANT } from 'Dictionaries/commonComponents/ObjectBlockEnums';
import { computed } from 'vue';

interface BlockDescriptionListData {
    company?: { name: string; link: string };
    contact?: { fullName: string; link: string };
    email?: string;
    phone_number?: string;
    mobile_number?: string;
    address?: { street: string; postal_code: string; city: string };
}

interface Props {
    data: BlockDescriptionListData;
    variant: OBJECT_BLOCK_VARIANT;
    showEmail?: boolean;
    showPhone?: boolean;
    showMobile?: boolean;
    showAddress?: boolean;
    showCompany?: boolean;
    showContact?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'BlockDescriptionListPart',
  props: {
    data: {},
    variant: {},
    showEmail: { type: Boolean, default: true },
    showPhone: { type: Boolean, default: true },
    showMobile: { type: Boolean, default: true },
    showAddress: { type: Boolean, default: true },
    showCompany: { type: Boolean, default: true },
    showContact: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const descriptionListVariant = computed<string>(() => {
    return props.variant === OBJECT_BLOCK_VARIANT.LINKED
        ? CompassEnums.DescriptionListVariantType.FROZEN_FIELD
        : CompassEnums.DescriptionListVariantType.LISTING;
});

const descriptionListSize = computed<string>(() => {
    return props.variant === OBJECT_BLOCK_VARIANT.LINKED
        ? CompassEnums.DescriptionListSize.MEDIUM
        : CompassEnums.DescriptionListSize.SMALL;
});



return (_ctx: any,_cache: any) => {
  const _component_CompassLink = _resolveComponent("CompassLink")!
  const _component_CompassDescriptionListItem = _resolveComponent("CompassDescriptionListItem")!
  const _component_CompassDescriptionList = _resolveComponent("CompassDescriptionList")!

  return (_openBlock(), _createBlock(_component_CompassDescriptionList, {
    size: descriptionListSize.value,
    variant: descriptionListVariant.value,
    class: "object-block__description-list"
  }, {
    default: _withCtx(() => [
      (__props.showCompany && __props.data.company)
        ? (_openBlock(), _createBlock(_component_CompassDescriptionListItem, {
            key: 0,
            label: _ctx.$t.__('email.EmailRelatedObject.company')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CompassLink, {
                label: __props.data.company.name,
                link: __props.data.company.link,
                target: "_blank"
              }, null, 8 /* PROPS */, ["label", "link"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"]))
        : _createCommentVNode("v-if", true),
      (__props.showContact && __props.data.contact)
        ? (_openBlock(), _createBlock(_component_CompassDescriptionListItem, {
            key: 1,
            label: _ctx.$t.__('common.labels.contact')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CompassLink, {
                label: __props.data.contact.fullName,
                link: __props.data.contact.link,
                target: "_blank"
              }, null, 8 /* PROPS */, ["label", "link"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"]))
        : _createCommentVNode("v-if", true),
      (__props.showEmail && __props.data.email)
        ? (_openBlock(), _createBlock(_component_CompassDescriptionListItem, {
            key: 2,
            label: _ctx.$t.__('common.labels.email')
          }, {
            default: _withCtx(() => [
              _createVNode(ContactDetails, {
                value: __props.data.email,
                variant: "email"
              }, null, 8 /* PROPS */, ["value"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"]))
        : _createCommentVNode("v-if", true),
      (__props.showPhone && __props.data.phone_number)
        ? (_openBlock(), _createBlock(_component_CompassDescriptionListItem, {
            key: 3,
            label: _ctx.$t.__('common.labels.phone')
          }, {
            default: _withCtx(() => [
              _createVNode(ContactDetails, {
                value: __props.data.phone_number,
                variant: "phone"
              }, null, 8 /* PROPS */, ["value"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"]))
        : _createCommentVNode("v-if", true),
      (__props.showMobile && __props.data.mobile_number)
        ? (_openBlock(), _createBlock(_component_CompassDescriptionListItem, {
            key: 4,
            label: _ctx.$t.__('common.labels.mobile')
          }, {
            default: _withCtx(() => [
              _createVNode(ContactDetails, {
                value: __props.data.mobile_number,
                variant: "phone"
              }, null, 8 /* PROPS */, ["value"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"]))
        : _createCommentVNode("v-if", true),
      (__props.showAddress && __props.data.address)
        ? (_openBlock(), _createBlock(_component_CompassDescriptionListItem, {
            key: 5,
            label: _ctx.$t.__('common.labels.address')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data.address.street), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString(__props.data.address.postal_code) + " " + _toDisplayString(__props.data.address.city), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["label"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["size", "variant"]))
}
}

})